import { Layout } from '@/components/Layout/Layout';
import ClientServicePage from 'components/PageLevelComponents/ClientServicePage';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { ServicesPageController } from 'server/controller/page/services/servicesPageController';
import type { IServicesPageResource } from 'server/resource/page/servicesPageResource';
import type { IGlobalMetaData } from 'types/IGlobalMetaData';

export default function Page(props: IServicesPageResource) {
  const {
    metaData,
    data,
    breadcrumbsCMSData,
    difficultyCopy,
    searchOverlayData,
    searchItemLabels,
    recipeCopy,
    footerNavData,
    footerImage,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    locale,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;
  return (
    <Layout
      themeName={data?.genericPages.at(0)?.theme || ''}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientServicePage
        globalMetadata={metaData as IGlobalMetaData}
        data={data}
        breadcrumbsCMSData={breadcrumbsCMSData}
        difficultyCopy={difficultyCopy as Record<string, string>}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchOverlayData={searchOverlayData}
        recipeCopy={recipeCopy}
        themeName={data?.genericPages.at(0)?.theme || ''}
      />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return ServicesPageController.getCachedServicesPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug : [],
    userToken: anonymousToken ?? '',
  });
};
